<template>
  <div class="container">
    <v-card>
      <v-toolbar dark color="primary">
        <v-toolbar-title>Gestión de Usuarios</v-toolbar-title>
      </v-toolbar>

      <v-row dense>
        <v-col cols="12" class="ml-3 mt-6">
          <v-checkbox
            v-model="soloActivos"
            label="Mostrar en la grilla solo usuarios activos"
            color="primary"
            dense
            @change="buscarUsuarios"
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="11" sm="4" class="ml-3">
          <v-text-field
            v-if="listaUsuarios.length"
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar Usuario"
            single-line
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>
      <v-data-table
        v-if="listaUsuarios.length"
        :headers="headers"
        :items="this.listaUsuarios"
        class="elevation-1"
        locale="es-ar"
        item-key="usuario"
        :items-per-page="10"
        :search="search"
        ref="myTable"
        :disable-sort="false"
        :footer-props="{
          itemsPerPageText: 'Filas por página',
        }"
      >
        <template v-slot:item.estadoUsuario="{ item }">
          <v-simple-checkbox
            v-model="item.estadoUsuario"
            disabled
          ></v-simple-checkbox>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                medium
                color="orange"
                class="mr-3"
                v-on="on"
                v-bind="attrs"
                @click.stop="cambiarPass(item)"
                >mdi-wrench</v-icon
              >
            </template>
            <span>Cambiar Contraseña</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-show="item.estadoUsuario == true"
                medium
                color="blue"
                class="mr-3"
                v-on="on"
                v-bind="attrs"
                @click.stop="desactivarUsuario(item)"
                >mdi-thumb-down</v-icon
              >
            </template>
            <span>Desactivar Usuario</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-show="!item.estadoUsuario"
                medium
                color="green"
                class="mr-3"
                v-on="on"
                v-bind="attrs"
                @click.stop="activarUsuario(item)"
                >mdi-thumb-up</v-icon
              >
            </template>
            <span>Activar Usuario</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                medium
                v-on="on"
                color="red"
                v-bind="attrs"
                @click="borrarUsuario(item)"
                >mdi-delete</v-icon
              >
            </template>
            <span>Eliminar Usuario</span>
          </v-tooltip>
        </template>
      </v-data-table>
      <v-alert class="mt-4" color="purple" dark outlined v-else>
        No hay usuarios {{ soloActivos ? "activos" : "" }} configurados para la
        institución.
      </v-alert>
      <v-card-actions>
        <v-btn dark color="#24232d" @click="salir">
          <v-icon left>mdi-arrow-left</v-icon>
          Volver
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="success" @click.stop="nuevoUsuario">Nuevo Usuario</v-btn>
      </v-card-actions>
      <NuevoUsuario
        :visible="showNuevoUsuario"
        @close="cierraNuevoUsuario()"
        @usuarioRegistrado="usuarioRegistrado()"
      ></NuevoUsuario>
      <CambiarPassUsuario
        :visible="showCambiarPassUsuario"
        :usuario="editedItem.usuario"
        @close="showCambiarPassUsuario = false"
      ></CambiarPassUsuario>
    </v-card>
  </div>
</template>
<style scoped>
::v-deep .v-data-table__empty-wrapper {
  display: none;
}
.container {
  margin: auto;
}
</style>
<script>
import axios from "@/axios-auth";
import router from "@/router";
import NuevoUsuario from "./NuevoUsuario.vue";
import CambiarPassUsuario from "./CambiarPassUsuario.vue";
import { showAlert } from "@/utils/toast";

export default {
  data: (vm) => ({
    listaUsuarios: [],
    headers: [
      { text: "Usuario", value: "usuario" },
      { text: "Estado", value: "estadoUsuario", sortable: false },
      { text: "Acciones", value: "actions", sortable: false },
    ],
    showNuevoUsuario: false,
    showCambiarPassUsuario: false,
    editedItem: {},
    editedIndex: -1,
    soloActivos: true,
    search: "",
  }),
  created() {
    this.buscarUsuarios(true);
  },
  methods: {
    salir() {
      router.push({ path: "/Home" });
    },

    showAlert(alertInfo) {
      showAlert(alertInfo);
    },
    borrarUsuario(item) {
      this.$swal({
        title: "Borrar Usuario",
        text: "¿Desea borrar el usuario?",
        icon: "success",
        background: "#ececec",
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
        showCancelButton: true,
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          //this.$swal('Turno g', 'You successfully deleted this file', 'success')

          const usuario = item.usuario;
          let self = this;
          axios
            .get("/Usuario/BorrarUsuario?", {
              params: {
                usuario: usuario,
                idInstitucion:
                  self.$store.state.usuario.institucion.idInstitucion,
              },
            })
            .then((response) => {
              if (response.data == "error") {
                self.showAlert({
                  icon: "warning",
                  title: "El usuario tiene roles y/o profesionales asociados.",
                  vm: self,
                  timer: 1800,
                });
              } else {
                self.showAlert({
                  icon: "success",
                  title: "Usuario borrado exitosamente.",
                  vm: self,
                  timer: 1800,
                });
                setTimeout(self.buscarUsuarios(), 1700);
              }
            })
            .catch((error) => {
              self.showAlert({
                icon: "warning",
                title: "El usuario no pudo ser borrado.",
                vm: this,
                timer: 1800,
              });
            });
        } else {
          //this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      });
    },
    cambiarPass(item) {
      this.editedIndex = this.listaUsuarios.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.showCambiarPassUsuario = true;
    },
    cierraNuevoUsuario() {
      this.showNuevoUsuario = false;
      //this.buscarUsuarios();
    },
    usuarioRegistrado() {
      this.showNuevoUsuario = false;
      this.buscarUsuarios();
    },
    nuevoUsuario() {
      this.showNuevoUsuario = true;
    },
    activarUsuario(item) {
      this.$swal({
        title: "Activar Usuario",
        text: "¿Desea activar el usuario?",
        icon: "success",
        background: "#ececec",
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
        showCancelButton: true,
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          //this.$swal('Turno g', 'You successfully deleted this file', 'success')

          const usuario = item.usuario;
          let self = this;
          axios
            .get("/Usuario/DesactivarActivarUsuario?", {
              params: {
                usuario: usuario,
                idInstitucion:
                  self.$store.state.usuario.institucion.idInstitucion,
                estadoUsuario: true,
              },
            })
            .then((response) => {
              self.showAlert({
                icon: "success",
                title: "Usuario activado exitosamente",
                vm: self,
              });
              setTimeout(self.buscarUsuarios(), 1700);
            })
            .catch((error) => {
              self.showAlert({
                icon: "warning",
                title: "El usuario no pudo ser activado.",
                vm: this,
                timer: 1800,
              });
            });
        } else {
          //this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      });
    },
    desactivarUsuario(item) {
      this.$swal({
        title: "Desactivar Usuario",
        text: "¿Desea desactivar el usuario?",
        icon: "success",
        background: "#ececec",
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
        showCancelButton: true,
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          //this.$swal('Turno g', 'You successfully deleted this file', 'success')

          const usuario = item.usuario;
          let self = this;
          axios
            .get("/Usuario/DesactivarActivarUsuario?", {
              params: {
                usuario: usuario,
                idInstitucion:
                  self.$store.state.usuario.institucion.idInstitucion,
                estadoUsuario: false,
              },
            })
            .then((response) => {
              self.showAlert({
                icon: "success",
                title: "Usuario desactivado exitosamente.",
                vm: self,
                timer: 1800,
              });
              setTimeout(self.buscarUsuarios(), 1700);
            })
            .catch((error) => {
              self.showAlert({
                icon: "warning",
                title: "El usuario no pudo ser desactivado.",
                vm: this,
                timer: 1800,
              });
            });
        } else {
          //this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      });
    },
    buscarUsuarios(sorting = false) {
      const filtrosData = {
        idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
        soloActivos: this.soloActivos,
      };
      const usuarioLogueado = this.$store.state.usuario.usuario;
      const esSigemed = usuarioLogueado.toLowerCase().includes("sigemed");

      let self = this;
      axios
        .get("/Usuario/BuscarUsuarios?", {
          params: {
            idInstitucion: filtrosData.idInstitucion,
            soloActivos: filtrosData.soloActivos,
          },
        })
        .then(function (response) {
          if (response.data != "" && response.data != null)
            self.listaUsuarios = esSigemed
              ? response.data
              : response.data
                  .filter(
                    (obj) => !obj.usuario.toLowerCase().includes("sigemed")
                  )
                  .map((item) => {
                    const grupo = item.nombreGrupoUsuario?.trim();
                    return {
                      ...item,
                      nombreUsuarioCompleto: grupo
                        ? `${item.usuario} - (${grupo})`
                        : item.usuario,
                      _tieneGrupo: !!grupo, // campo auxiliar para ordenar
                    };
                  })
                  .sort((a, b) => {
                    if (a._tieneGrupo && !b._tieneGrupo) return -1;
                    if (!a._tieneGrupo && b._tieneGrupo) return 1;

                    // Si ambos tienen grupo (o ambos no), ordeno alfabéticamente por grupo
                    const grupoA = a.nombreGrupoUsuario?.toLowerCase() || "";
                    const grupoB = b.nombreGrupoUsuario?.toLowerCase() || "";
                    return grupoA.localeCompare(grupoB);
                  });
          else self.listaUsuarios = [];
        })
        .catch(function (error) {});
    },
  },

  components: {
    NuevoUsuario,
    CambiarPassUsuario,
  },
};
</script>
